module.exports = __webpack_public_path__ + "b91bdbab3bc91a5e85844090150e9a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/965fm.png
// module id = 1369
// module chunks = 47